import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=1c33f016&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"
import style0 from "./textarea.vue?vue&type=style&index=0&id=1c33f016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33f016",
  null
  
)

export default component.exports